<h1 mat-dialog-title>Dialog with elements</h1>
<div mat-dialog-content>
    Liverpool
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>